export default {"src":"/_next/static/media/junk_mail.67092c9a.svg","height":78,"width":72};